import { styled } from 'styled-components'

export const PairExploreItemBondingBg = styled.div`
  position: absolute;
  inset: 0;
  border-radius: var(--card-border-radius);
  transition: all 0.3s linear;
  clip-path: polygon(
    100% 100%,
    0 100%,
    0 0,
    100% 0,
    var(--bonding-pct) 0,
    var(--bonding-pct) 100%
  );

  background: rgba(3, 152, 129, 0.1);
  border: 1px solid var(--success-9);
`
